import { render } from "./ProsesGaleri.vue?vue&type=template&id=678fcc82"
import script from "./ProsesGaleri.vue?vue&type=script&lang=js"
export * from "./ProsesGaleri.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__